import React from "react";
import LinkItem from "./shared/link-item.jsx";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";

export default class ReportsMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            title: "",
            links: [
                {
                    "text": "Manage Pages",
                    "url": "manage-pages"
                },
                {
                    "text": "Manage Forms",
                    "url": "manage-forms"
                },
                {
                    "text": "Manage Announcement",
                    "url": "manage-announcement"
                },
                {
                    "text": "Manage News & Events",
                    "url": "manage-news"
                }
            ]
        };

        this.loadViewModel = this.loadViewModel.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();
    }

    loadViewModel() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get("marketing-admin")
            .then(function (res) {
                self.setState({
                    title: res.data.title
                });
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    handleChange(event) {
        let url = event.target.url.trim();
        window.location = context.root() + '/' + url;
    }

    render() {
        let self = this;
        let baseUrl = context.root();
        var linksToRender = this.state.links.map(function (link, i) {
            if (link.url.indexOf('.aspx') >= 0) {
                let url = baseUrl.replace('v2/', '').replace('v2', '') + '' + link.url;
                return <LinkItem key={i} text={link.text} url={url} onClick={this.handleChange} />
            }
            else {
                return <LinkItem key={i} text={link.text} url={link.url} onClick={this.handleChange} />
            }
        }, this);

        return (
            <div className="container">
                <div className="row">
                    <h2 className="text-center ap-title">{this.state.title}</h2>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <ul className="nav navbar-nav">
                            {linksToRender}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}